module.exports = __webpack_public_path__ + "img/IMG-20200226-WA0010.e8c45057.jpg";